var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69336 8.62987e-06C2.5632 -0.000546502 2.43433 0.0256864 2.31474 0.0770754C2.19516 0.128464 2.08743 0.20391 1.99826 0.298719C1.81602 0.485782 1.70972 0.733839 1.69996 0.994813V18.913C1.69937 19.0433 1.72555 19.1723 1.77686 19.292C1.82817 19.4118 1.90353 19.5197 1.99826 19.6091C2.08841 19.7026 2.19634 19.7773 2.3157 19.8285C2.43506 19.8798 2.56347 19.9068 2.69338 19.9078H17.2702C17.4004 19.9083 17.5292 19.882 17.6488 19.8306C17.7684 19.7793 17.8761 19.7038 17.9654 19.6091C18.0586 19.5185 18.133 19.4104 18.1842 19.2909C18.2354 19.1714 18.2624 19.043 18.2637 18.913V5.63901L12.6314 8.62987e-06H2.69336Z",
    fill: "#FF4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5054 14.986V10.4059L10.0051 13.3407L7.50759 10.4059V14.9873L5 13.919V7H7.50036L10.0007 9.9362L12.4996 7H15V16L12.5054 14.986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2636 5.639H13.626C13.0826 5.62599 12.645 5.1883 12.6313 4.6442V0L18.2636 5.639Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.b17ee2c43e2d5b06f04fb03d10fe6e09.svg";
export { ForwardRef as ReactComponent };